module.exports = __webpack_public_path__ + "static/head-pic1-962b4dcc90454aef1714a2b338435fdc.png";